import styles from './loading-section.module.scss'

function LoadingSection() {
    return (
        <div className={styles.loadingSection}>
            <div className={styles.loadingSection__loader} />
        </div>
    )
}

export default LoadingSection
